import { Component } from 'react';

import AppInfo from '../app-info/app-info';
import SearchPanel from '../search-panel/search-panel';
import AppFilter from '../app-filter/app-filter';
import EmployeesList from '../employees-list/employees-list';
import EmployeesAddForm from '../employees-add-form/employees-add-form';

import './App.css';


class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [
        { name: 'Jhon C.', salary: 1500, increase: false, rise: true, id: 1 },
        { name: 'Julia C.', salary: 2000, increase: true, rise: false, id: 2 },
        { name: 'Anna D.', salary: 800, increase: false, rise: false, id: 3 }
      ],
      filter: 'all',
      term: ''
    }
    this.maxId = this.state.data.length
  }

  onToggle = (id, prop) => {
    this.setState(({ data }) => ({
      data: data.map(item => {
        if (item.id === id) {
          return { ...item, [prop]: !item[prop] }
        }
        return item
      })
    }))
  }

  onDeleteItem = (id) => {
    this.setState(({ data }) => {
      return {
        data: data.filter(item => item.id !== id)
      }
    })
  }

  onAddItem = (name, salary) => {
    const newItem = {
      name,
      salary,
      increase: false,
      rise: false,
      id: ++this.maxId
    }

    this.setState(({ data }) => {
      return {
        data: [newItem, ...data]
      }
    })
  }

  onChangeSalary = (id, salary) => {
    this.setState(({ data }) => ({
      data: data.map(item => {
        if (item.id === id) {
          return { ...item, salary: parseFloat(salary) }
        }
        return item
      })
    }))
  }

  filterPost = (items, filter) => {
    switch (filter) {
      case 'rise':
        return items.filter(item => item.rise);
      case 'moreThen1000':
        return items.filter(item => item.salary > 1000);
      case 'increase':
        return items.filter(item => item.increase)
      default:
        return items
    }
  }

  searchEmp = (items, term) => {
    if (term.length === 0) {
      return items;
    }

    return items.filter(item => item.name.indexOf(term) > -1)
  }

  onUpdateSearch = (term) => {
    this.setState({ term });
  }

  onFilterSelect = (filter) => {
    this.setState({ filter })
  }

  render() {
    const { data, filter, term } = this.state

    const employees = this.state.data.length,
      boost = this.state.data.filter(item => item.rise).length,
      increased = this.state.data.filter(item => item.increase).length,
      visibleData = this.filterPost(this.searchEmp(data, term), filter);


    return (
      <div className="app">
        <AppInfo employees={employees} boost={boost} increased={increased} />

        <div className="search-panel">
          <SearchPanel onUpdateSearch={this.onUpdateSearch} />
          <AppFilter filter={filter} filterPost={this.onFilterSelect} />
        </div>

        <EmployeesList data={visibleData} onToggle={this.onToggle} onDeleteItem={this.onDeleteItem} onChangeSalary={this.onChangeSalary} />
        <EmployeesAddForm onAddItem={this.onAddItem} />
      </div>
    );
  };
}

export default App;